module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"description":"Description","upload":"Send"},"fr":{"description":"Description","upload":"Envoyer"}}')
  delete Component.options._Ctor
}
